import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchCornermarks,
  SearchCornermarksVariables
} from "./types/SearchCornermarks";

export const searchCornermarks = gql`
  ${pageInfoFragment}
  query SearchCornermarks(
    $after: String
    $first: Int!
    $query: String!
    $type: CornerMarkTypeEnum
  ) {
    search: cornerMarks(
      after: $after
      first: $first
      filter: { search: $query, type: $type }
    ) {
      edges {
        node {
          id
          titleText
          textColor
          mainColor
          secondaryColor
          isGradientColour
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchCornermarks,
  SearchCornermarksVariables
>(searchCornermarks);
